import { Api } from "../config/request";

export default {
  getGroomingSelfiesList(queryParams) {
    return Api.get(`/drivers/selfies${queryParams}`);
  },
};
